import { allComparisons } from "./curiosities-config";
import { calculateComparisonValue, calculateScore } from "./calculations";
import { CURIOSITIES_TEST_MODE } from "./constants";
import { RetrospectiveData } from "./types";

export function selectBestCuriosities(
	totalPeople: number,
	type: "cashless" | "ficha",
	operatingTime?: { daysOfOperation: number; minutesInYear: number; hoursWorked: number },
	qtdLitrosCervejas?: number,
): RetrospectiveData["curiosities"] {
	const filteredComparisons = allComparisons.filter(comparison =>
		comparison.allowedTypes.includes(type),
	);

	const calculatedComparisons = filteredComparisons.map(comparison => {
		const value = calculateComparisonValue(
			comparison,
			totalPeople,
			operatingTime,
			qtdLitrosCervejas,
		);
		return {
			...comparison,
			calculatedValue: value,
			score: calculateScore(value),
		};
	});

	// Modo teste: retorna todos ordenados
	if (CURIOSITIES_TEST_MODE) {
		return calculatedComparisons
			.sort((a, b) => b.score - a.score)
			.map(comp => {
				const number =
					comp.calculatedValue < 10
						? Math.floor(comp.calculatedValue * 10) / 10
						: Math.floor(comp.calculatedValue);
				return {
					id: comp.id,
					image: comp.image,
					title: comp.name,
					number,
					color: comp.color,
					description: comp.description,
					category: comp.category,
				};
			});
	}

	// Modo produção: seleciona por categoria
	// 1 operationTime + 1 beer + 2 people ou 1 products
	const selectedComparisons: typeof calculatedComparisons = [];

	// Categorias para pegar comparativos (baseado no tipo)
	const mainCategory = type === "cashless" ? "people" : "products";
	const mainCategoryCount = type === "cashless" ? 2 : 1; // 2 para people, 1 para products

	// Separar por categoria e ordenar por score
	const byCategory = {
		operationTime: calculatedComparisons
			.filter(
				c => c.category === "operationTime" && c.score > 0 && c.calculatedValue >= 1,
			)
			.sort((a, b) => b.score - a.score),
		beer: calculatedComparisons
			.filter(c => c.category === "beer" && c.score > 0 && c.calculatedValue >= 1)
			.sort((a, b) => b.score - a.score),
		main: calculatedComparisons
			.filter(c => c.category === mainCategory && c.score > 0 && c.calculatedValue >= 1)
			.sort((a, b) => b.score - a.score),
	};

	// Pegar 1 de operationTime
	if (byCategory.operationTime.length > 0) {
		selectedComparisons.push(byCategory.operationTime[0]);
	}

	// Pegar 1 de beer
	if (byCategory.beer.length > 0) {
		selectedComparisons.push(byCategory.beer[0]);
	}

	// Pegar da categoria principal (2 para people, 1 para products)
	selectedComparisons.push(...byCategory.main.slice(0, mainCategoryCount));

	return selectedComparisons.map(comp => {
		const number =
			comp.calculatedValue < 10
				? Math.floor(comp.calculatedValue * 10) / 10
				: Math.floor(comp.calculatedValue);

		return {
			id: comp.id,
			image: comp.image,
			title: comp.name,
			number,
			color: comp.color,
			description: comp.description,
			category: comp.category,
		};
	});
}
